'use client';

import { useEffect, useState } from 'react';

function isMobileType(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.match(/iphone os/i)?.[0] === 'iphone os') {
    return true;
  }

  if (userAgent.match(/android/i)?.[0] === 'android') {
    return true;
  }

  return false;
}

export enum LAYOUT_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

// iphone、android 直接为 true，其他 平板、PC 等根据屏幕尺寸判断
function useLayoutSize(): LAYOUT_SIZE | undefined {
  const [layoutSize, setLayoutSize] = useState<LAYOUT_SIZE | undefined>(undefined);

  useEffect(() => {
    const mqSmall = window.matchMedia('(max-width: 720px)');
    const mqMedium = window.matchMedia('(min-width: 721px) and (max-width: 1179px)');
    const mqLarge = window.matchMedia('(min-width: 1180px)');

    function updateLayoutSize() {
      if (isMobileType() || mqSmall.matches) {
        setLayoutSize(LAYOUT_SIZE.SMALL);
      } else if (mqMedium.matches) {
        setLayoutSize(LAYOUT_SIZE.MEDIUM);
      } else if (mqLarge.matches) {
        setLayoutSize(LAYOUT_SIZE.LARGE);
      }
    }

    updateLayoutSize();

    mqSmall.addEventListener('change', updateLayoutSize);
    mqMedium.addEventListener('change', updateLayoutSize);
    mqLarge.addEventListener('change', updateLayoutSize);

    return () => {
      mqSmall.removeEventListener('change', updateLayoutSize);
      mqMedium.removeEventListener('change', updateLayoutSize);
      mqLarge.removeEventListener('change', updateLayoutSize);
    };
  }, []);

  return layoutSize;
}

export default useLayoutSize;
